function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, prompt } from '@kuaizhan/kui';
import HeaderMsgItem from './header-msg-item';
import HeaderMsgDialog from './header-msg-dialog';

var getMsgById = function getMsgById(list, id) {
  var result;
  list.some(function (item) {
    if (id === item.id) {
      result = _objectSpread({}, item);
      return true;
    }

    return false;
  });
  return result || null;
};

var HeaderMsg = /*#__PURE__*/function (_Component) {
  _inherits(HeaderMsg, _Component);

  var _super = _createSuper(HeaderMsg);

  function HeaderMsg(props) {
    var _this;

    _classCallCheck(this, HeaderMsg);

    _this = _super.call(this, props);
    _this.state = {
      isShowMsg: false,
      hideDialog: true,
      curMsg: {
        title: '',
        content: ''
      }
    };
    _this.handleReadAllMsg = _this.handleReadAllMsg.bind(_assertThisInitialized(_this));
    _this.handleShowMsgToggle = _this.handleShowMsgToggle.bind(_assertThisInitialized(_this));
    _this.handleReadMsgItem = _this.handleReadMsgItem.bind(_assertThisInitialized(_this));
    _this.handleConfirmRead = _this.handleConfirmRead.bind(_assertThisInitialized(_this));
    return _this;
  } // 事件处理程序-点击显示消息列表事件


  _createClass(HeaderMsg, [{
    key: "handleShowMsgToggle",
    value: function handleShowMsgToggle() {
      this.setState({
        isShowMsg: !this.state.isShowMsg
      });
    } // 阅读一条

  }, {
    key: "handleReadMsgItem",
    value: function handleReadMsgItem(id) {
      var _this$props = this.props,
          onReadMsgItem = _this$props.onReadMsgItem,
          msgList = _this$props.msgList;
      onReadMsgItem(id);
      var msg = getMsgById(msgList, id);

      if (!msg) {
        prompt.alert('信息不存在！');
        return;
      }

      if (msg.url) {
        window.open(msg.url);
        return;
      }

      this.setState({
        curMsg: {
          title: msg.title,
          content: msg.content
        },
        hideDialog: false
      });
    } // 阅读全部

  }, {
    key: "handleReadAllMsg",
    value: function handleReadAllMsg() {
      var onReadAllMsg = this.props.onReadAllMsg;
      onReadAllMsg();
    }
  }, {
    key: "handleConfirmRead",
    value: function handleConfirmRead() {
      this.setState({
        hideDialog: true
      });
    }
  }, {
    key: "renderMsgList",
    value: function renderMsgList() {
      var _this2 = this;

      var msgList = this.props.msgList;
      if (msgList.length === 0) return null;
      return msgList.map(function (msgItem, index) {
        return /*#__PURE__*/React.createElement(HeaderMsgItem, {
          key: msgItem.id || index,
          onClick: function onClick() {
            _this2.handleReadMsgItem(msgItem.id);
          },
          title: msgItem.title,
          content: msgItem.content,
          isImportant: msgItem.isImportant,
          isClicked: msgItem.isClicked
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isShowMsg = _this$state.isShowMsg,
          hideDialog = _this$state.hideDialog,
          curMsg = _this$state.curMsg;
      var unreadNum = this.props.unreadNum;
      return /*#__PURE__*/React.createElement("div", {
        className: isShowMsg ? 'header-cell header-msg header-msg-show' : 'header-cell header-msg'
      }, /*#__PURE__*/React.createElement("span", {
        role: "button",
        tabIndex: 0,
        className: "msg-icon-wrap",
        onClick: this.handleShowMsgToggle
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "msg-icon",
        iconClass: "kz-e-tips"
      }), unreadNum > 0 ? /*#__PURE__*/React.createElement("span", {
        className: "msg-num"
      }, unreadNum > 99 ? '99+' : unreadNum) : null), /*#__PURE__*/React.createElement("div", {
        className: "msg-panel"
      }, /*#__PURE__*/React.createElement("div", {
        className: "msg-triangle"
      }), /*#__PURE__*/React.createElement("div", {
        className: "panel-head"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "head-title"
      }, "\u6211\u7684\u6D88\u606F"), /*#__PURE__*/React.createElement("span", {
        role: "button",
        tabIndex: 0,
        className: unreadNum === 0 ? 'head-read head-read-clicked' : 'head-read',
        onClick: this.handleReadAllMsg
      }, "\u5168\u90E8\u5DF2\u8BFB")), /*#__PURE__*/React.createElement("div", {
        className: "panel-content"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "content-list"
      }, this.renderMsgList()))), /*#__PURE__*/React.createElement(HeaderMsgDialog, {
        hide: hideDialog,
        curMsg: curMsg,
        onConfirm: this.handleConfirmRead
      }));
    }
  }]);

  return HeaderMsg;
}(Component);

HeaderMsg.defaultProps = {
  unreadNum: 0,
  msgList: [],
  onReadAllMsg: function onReadAllMsg() {},
  onReadMsgItem: function onReadMsgItem() {}
};
HeaderMsg.propTypes = {
  unreadNum: PropTypes.number,
  msgList: PropTypes.arrayOf(PropTypes.object),
  onReadAllMsg: PropTypes.func,
  onReadMsgItem: PropTypes.func
};
export default HeaderMsg;